module.exports = __webpack_public_path__ + "img/Al-Jadiriya2.29b2effe.jpg";